import { createReducer, on } from '@ngrx/store';
import { granteeInitialState } from '../state/grantee-initial.state';
import {
    ineligibleScenariosForGranteeInGranteeFlow,
    ineligibleScenariosForGranteeInGranteeFlowError,
    ineligibleScenariosForGranteeInGranteeFlowSuccess,
} from '../actions/ineligible-scenarios.action';
import {
    setAcceptPermissionResult,
    setBulkAcceptResponse,
    setGranteeRegulatoryQuestions,
    updateAccessTypeInGranteeFlow,
    updateClientTypeInGranteeFlow,
    updateIsMultiAccountInGranteeFlow,
} from '../actions/grantee-flow.actions';
import { LiteRegRedirectError } from '../actions/pvr-redirect.actions';

export const granteeReducer = createReducer(
    granteeInitialState,

    on(ineligibleScenariosForGranteeInGranteeFlow, (state) => {
        return {
            ...state,
            isLoading: true,
            error: null,
        };
    }),

    on(
        ineligibleScenariosForGranteeInGranteeFlowSuccess,
        (state, { granteeIneligibleReason: GranteeIneligibleReasons }) => {
            return {
                ...state,
                isLoading: false,
                error: null,
                granteeIneligibleReason: GranteeIneligibleReasons,
            };
        },
    ),

    on(ineligibleScenariosForGranteeInGranteeFlowError, (state, { error }) => {
        return {
            ...state,
            isLoading: false,
            error,
        };
    }),

    on(updateAccessTypeInGranteeFlow, (state, { accessType }) => {
        return {
            ...state,
            accessType,
        };
    }),

    on(updateClientTypeInGranteeFlow, (state, { clientType }) => {
        return {
            ...state,
            clientType,
        };
    }),

    on(
        setGranteeRegulatoryQuestions,
        (state, { isVanguardEmployee, isAssociatedPerson, isControlPerson }) => ({
            ...state,
            granteeRegulatoryQuestions: {
                isVanguardEmployee,
                isAssociatedPerson,
                isControlPerson,
            },
        }),
    ),

    on(LiteRegRedirectError, (state, { error }) => ({
        ...state,
        error,
    })),

    on(setAcceptPermissionResult, (state, { hasFullRegError }) => ({
        ...state,
        hasFullRegError,
    })),

    on(setBulkAcceptResponse, (state, { response }) => ({
        ...state,
        bulkAcceptResponse: response,
    })),

    on(updateIsMultiAccountInGranteeFlow, (state, { isMultiAccount }) => ({
        ...state,
        isMultiAccount,
    })),
);
